// auto-generated by Typewriter template _enums.tst from PortCall.Models\DomainSettings\HomepageSettings.cs
export enum HomepageTabVisibility { 
    Public = 0,
    LoggedIn = 10,
    Off = 20
}

export const HomepageTabVisibilityDisplayName : { [val : number] : string } = { 
    0: 'Public',
    10: 'LoggedIn',
    20: 'Off'
}

export const HomepageTabVisibilitys : { Id : HomepageTabVisibility, Name : string }[] = [ 
    { Id: HomepageTabVisibility.Public, Name: 'Public' },
    { Id: HomepageTabVisibility.LoggedIn, Name: 'LoggedIn' },
    { Id: HomepageTabVisibility.Off, Name: 'Off' }
]



// WEBPACK FOOTER //
// ./server/enums/HomepageTabVisibility.ts